import { createStateContext } from 'ui/helpers/context';

import { ExtendedUploadFile } from './types';

export const { Provider: FileListProvider, useContext: useFileListContext } = createStateContext<
  ExtendedUploadFile[]
>([]);

export const { Provider: FileLoadingProvider, useContext: useFileLoadingContext } =
  createStateContext<boolean>(false);
